/**
 * supportAccessService.js — acceso de soporte CON PERMISO del usuario.
 *
 * Un admin pide permiso para entrar en una cuenta; el usuario, que tiene que
 * estar conectado, acepta o deniega desde un modal; si acepta, el admin entra
 * con la impersonación de siempre. Ver `QR/support_access/services.py`.
 *
 * Lado usuario (/api/v1/support-access/):
 *   GET  /current/            ¿hay una solicitud o una sesión? (cada 5 s)
 *   POST /<id>/respond/       { decision: 'accept' | 'deny' }
 *   POST /<id>/revoke/        echar al soporte
 *
 * Lado admin (/api/v1/mgmt/):
 *   POST /users/<id>/support-access/          pedir permiso
 *   GET  /support-access/<id>/                estado de la solicitud
 *   POST /support-access/<id>/cancel/
 *   POST /support-access/<id>/enter/          consumir el permiso y entrar
 *   GET  /impersonate/state/                  la barra vigila la sesión
 */
import httpClient from './httpClient';

// ── Usuario ────────────────────────────────────────────────────────────────

/** → { pending: {id, deadlineAt, maxMinutes}|null, active: {id, startedAt, expiresAt}|null,
 *      endedRecently: {id, reason}|null } */
export async function getCurrentSupportAccess() {
  const { data } = await httpClient.get('/support-access/current/');
  return {
    pending: data?.pending || null,
    active: data?.active || null,
    endedRecently: data?.endedRecently || null,
  };
}

export async function respondSupportAccess(requestId, accept) {
  const { data } = await httpClient.post(`/support-access/${requestId}/respond/`, {
    decision: accept ? 'accept' : 'deny',
  });
  return data;
}

export async function revokeSupportAccess(requestId) {
  const { data } = await httpClient.post(`/support-access/${requestId}/revoke/`);
  return data;
}

// ── Admin ──────────────────────────────────────────────────────────────────

/** → { id, status, targetId, deadlineAt, endReason } */
export async function requestSupportAccess(userId) {
  const { data } = await httpClient.post(`/mgmt/users/${userId}/support-access/`);
  return data;
}

export async function getSupportAccessRequest(requestId) {
  const { data } = await httpClient.get(`/mgmt/support-access/${requestId}/`);
  return data;
}

export async function cancelSupportAccessRequest(requestId) {
  const { data } = await httpClient.post(`/mgmt/support-access/${requestId}/cancel/`);
  return data;
}

export async function enterWithSupportAccess(requestId) {
  const { data } = await httpClient.post(`/mgmt/support-access/${requestId}/enter/`);
  return data;
}

/** → el estado de la impersonación, o { active: false, endReason } */
export async function getImpersonationState() {
  const { data } = await httpClient.get('/mgmt/impersonate/state/');
  return data;
}
